import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.548 9.081C21.548 5.446 18.617 2.5 15 2.5c-3.617 0-6.548 2.946-6.548 6.581 0 5.208 6.548 12.914 6.548 12.914s6.55-7.733 6.55-12.914Zm-9.778-.393A3.238 3.238 0 0 1 15 5.442a3.238 3.238 0 0 1 3.23 3.246A3.238 3.238 0 0 1 15 11.934a3.238 3.238 0 0 1-3.23-3.246Z" }, null, -1),
    _createElementVNode("path", { d: "M14.999 10.284c.877 0 1.588-.715 1.588-1.596 0-.882-.711-1.596-1.588-1.596-.877 0-1.588.714-1.588 1.596 0 .881.71 1.596 1.588 1.596ZM18.702 19.705a46.92 46.92 0 0 1-1.452 1.993c4.138.25 6.85 1.147 7.859 1.815-1.182.784-4.694 1.885-10.109 1.885-5.414 0-8.927-1.102-10.108-1.885 1.008-.667 3.718-1.565 7.852-1.815a46.374 46.374 0 0 1-1.454-1.992c-5.092.504-8.79 2.018-8.79 3.807 0 2.201 5.597 3.986 12.5 3.986 6.904 0 12.5-1.784 12.5-3.986.001-1.79-3.701-3.305-8.798-3.808Z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "pin"}) } }